import CalloutBox from "../../../../src/components/Docs/CalloutBox";
import Tab from "components/Tab";
import CursorSnippet from "../../../../contents/docs/model-context-protocol/_snippets/cursor.mdx";
import ClaudeDesktopSnippet from "../../../../contents/docs/model-context-protocol/_snippets/claude-desktop.mdx";
import WindsurfSnippet from "../../../../contents/docs/model-context-protocol/_snippets/windsurf.mdx";
import VSCodeSnippet from "../../../../contents/docs/model-context-protocol/_snippets/vscode.mdx";
import ClaudeCodeSnippet from "../../../../contents/docs/model-context-protocol/_snippets/claude-code.mdx";
import ZedSnippet from "../../../../contents/docs/model-context-protocol/_snippets/zed.mdx";
import MCPTools from "../../../../src/components/Docs/MCPTools";
import * as React from 'react';
export default {
  CalloutBox,
  Tab,
  CursorSnippet,
  ClaudeDesktopSnippet,
  WindsurfSnippet,
  VSCodeSnippet,
  ClaudeCodeSnippet,
  ZedSnippet,
  MCPTools,
  React
};